import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `Dossier/${dossierId}/DeleteEntityChild`, method: 'PUT', token: token })
}
